<template>
  <div class="charts-histogram">
    <canvas
      ref="mountNode"
      style="width: 100%;"
    ></canvas>
  </div>
</template>

<script>
import F2 from '@antv/f2';

export default {
  name: 'SmoothedLineChart',
  props: {
    data: {
      type: Array,
      default() {
        return [];
      },
    },
    config: {
      type: Object,
      default() {
        return {
          legendConfig: {},
          xKey: 'month',
          xTitle: '月份',
          yKey: 'value',
          yTitle: '业绩（元）',
          groupKey: '月份',
        };
      },
    },
    isShowLegend: {
      require: false,
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      chart: null,
      legendParam: false,
    };
  },
  watch: {
    data() {
      this.refresh();
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    refresh() {
      this.chart.clear();
      this.init();
    },
    init() {
      const { data } = this;
      const {
        xKey,
        yKey,
        groupKey,
        xTitle,
        yTitle,
        legendConfig,
        xAisRotate,
      } = this.config;
      const chart = new F2.Chart({
        height: 280,
        el: this.$refs.mountNode,
        pixelRatio: window.devicePixelRatio,
        appendPadding: [15, 20, 28, 15],
      });

      this.chart = chart;
      chart.source(data);

      const xList = [...new Set(this.data.map(item => item[xKey]))];

      // 间距 = Math.ceil(总个数 / 可显示个数)
      const x = [];
      const len = xList.length;
      const step = Math.ceil(len / 12);
      for (let i = 0; i < len; i += step) {
        x.push(xList[i]);
      }
      chart.scale(xKey, {
        ticks: x,
      });

      if (xAisRotate) {
        chart.axis(xKey, {
          label: {
            rotate: -Math.PI / 3,
            textAlign: 'end',
            textBaseline: 'middle',
          },
        });
      }
      if (this.isShowLegend) {
        this.legendParam = {
          position: 'bottom',
          align: 'center',
          offsetY: -35,
        };
      }
      chart.legend(this.legendParam);

      chart.tooltip({
        showCrosshairs: true,
        custom: true, // 自定义 tooltip 内容框
        onChange: (obj) => {
          this.$emit('showLegend', obj.items);
        },
        onHide: () => {
          this.$emit('hideLegend');
        },
      });

      if (data.length) {
        chart.guide().text({
          position: ['0%', '0%'],
          content: yTitle,
          style: {
            fillStyle: '#999999',
            fontSize: '12px',
            textAlign: 'left',
            opacity: '50%',
          },
          offsetX: -20,
          offsetY: -20,
        });

        chart.guide().text({
          position: ['100%', '100%'],
          content: xTitle,
          style: {
            fillStyle: '#999999',
            fontSize: '12px',
            textAlign: 'left',
            opacity: '50%',
          },
          offsetX: -5,
          offsetY: 12,
        });
      }
      chart
        .line()
        .shape('smooth')
        .position(`${xKey}*${yKey}`)
        .color(groupKey, val => legendConfig[val] || '#DE766F');

      chart.render();
    },
  },
};
</script>
